import { MediaType, tvpil } from '../../../data/compat/tvpil';
import { KalturaAssetIdentifier } from '../../composed';
import {
  createAggregationCountFilter,
  createAssetMetaOrTagGroupBy,
  createChannelFilter,
  createDetachedResponseProfile,
  createOnDemandResponseProfile,
  createPager,
} from '../../factories';
import { phoenixConfig } from '../../network';
import { fetchAssetList } from '../../services';
import { withCollectionFallback } from '../utils';

type FetchChannelCollectionArgs = {
  collectionId: number;
  groupBy?: string;
  includeAdult: boolean;
  kSql?: string;
};

export async function fetchChannelCollection({
  collectionId,
  groupBy,
  includeAdult,
  kSql,
}: FetchChannelCollectionArgs) {
  const assetKsql = getKsql({ kSql, includeAdult });
  const assetGroupBy = groupBy ? [createAssetMetaOrTagGroupBy({ value: groupBy })] : undefined;

  const relatedProfiles = groupBy
    ? [
        createDetachedResponseProfile({
          name: 'group_result',
          filter: createAggregationCountFilter({}),
        }),
      ]
    : undefined;

  const responseProfile = createOnDemandResponseProfile({
    retrievedProperties: 'id, error',
    relatedProfiles,
  });

  const kalturaAssetIdentifiers = await withCollectionFallback(() =>
    fetchAssetList<KalturaAssetIdentifier>({
      filter: createChannelFilter({
        idEqual: collectionId,
        groupBy: assetGroupBy,
        kSql: assetKsql,
      }),
      pager: createPager({
        pageIndex: 1,
        pageSize: 500,
      }),
      responseProfile,
    }),
  );

  return {
    ...kalturaAssetIdentifiers, // backward compatibility
    collection: kalturaAssetIdentifiers.objects.map((i) => i.id),
  };
}

function getKsql({ kSql, includeAdult }: { kSql?: string; includeAdult: boolean }) {
  const resKsql = [`asset_type='${phoenixConfig.assetsMediaTypes[MediaType.Linear]}'`, !includeAdult && `adult!='1'`]
    .filter(Boolean)
    .join(' ');

  return tvpil.addKsql(kSql || '(and )', resKsql);
}
